import { formatDisplayDate } from "../../utils/dateUtils";

export default function ProjectStageHeader({
  stageDef,
  activeAssignments,
  isTerminalStage,
  isCurrent,
}) {
  const primary = activeAssignments[0] || null;

  return (
    <div className="stage-detail-header">
      <div className="stage-detail-title-row">
        <h2 className="stage-detail-name">{stageDef.name}</h2>
        <div className="stage-detail-badges">
          {isCurrent && (
            <span className="badge badge--current">Current Stage</span>
          )}
          {isTerminalStage && (
            <span className="badge badge--terminal">Final Stage</span>
          )}
        </div>
      </div>

      {primary && (
        <div className="stage-detail-meta">
          {primary.assignee && (
            <span className="meta-item">
              👤 {primary.assignee.firstName} {primary.assignee.lastName}
            </span>
          )}
          {primary.expectedEndDate && (
            <span className="meta-item">
              📅 Due{" "}
              {formatDisplayDate(primary.expectedEndDate, {
                day: "numeric",
                month: "short",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
              })}
            </span>
          )}
          {primary.assignedBy && (
            <span className="meta-item">
              Assigned by {primary.assignedBy.firstName}{" "}
              {primary.assignedBy.lastName}
            </span>
          )}
        </div>
      )}

      {stageDef.description && (
        <p className="stage-detail-description">{stageDef.description}</p>
      )}
    </div>
  );
}
